import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "app/store.ts";
import type { BOLCountyFilters, BOLCountySlice } from "./bolCountiesTypes.ts";

const initialState: BOLCountySlice = {
  page: 1,
  rowsPerPage: 25,
  filter: {},
  sort: {
    key: "name",
    order: "asc",
  },
};

export const bolCountiesSlice = createSlice({
  name: "bolCounties",
  initialState,
  reducers: {
    setPage: (state, action: PayloadAction<BOLCountySlice["page"]>) => {
      state.page = action.payload;
    },
    setRowsPerPage: (
      state,
      action: PayloadAction<BOLCountySlice["rowsPerPage"]>,
    ) => {
      state.rowsPerPage = action.payload;
    },
    setFilter: (
      state,
      action: PayloadAction<
        [filterType: keyof BOLCountyFilters, filterValue: string | undefined]
      >,
    ) => {
      const [filterType, filterValue] = action.payload;
      state.filter[filterType] = filterValue;
    },
    setSort: (state, action: PayloadAction<BOLCountySlice["sort"]>) => {
      state.sort = action.payload;
    },
  },
});

export const { setPage, setRowsPerPage, setFilter, setSort } =
  bolCountiesSlice.actions;

export const selectPage = (state: RootState) => state.bolCounties.page;
export const selectRowsPerPage = (state: RootState) =>
  state.bolCounties.rowsPerPage;
export const selectFilter = (state: RootState) => state.bolCounties.filter;
export const selectSort = (state: RootState) => state.bolCounties.sort;

export default bolCountiesSlice.reducer;
